let sequenciaChave = 0;

export function novaChaveAtividade() {
  sequenciaChave += 1;
  return `${Date.now()}-${sequenciaChave}`;
}

export function chaveItemOrcamento(item) {
  if (!item) return '';
  return String(
    item.propOrcItem_id ??
    item.value ??
    item.id ??
    item.propItem_id ??
    ''
  );
}

export function itemEhRecursoHumano(item) {
  return Number(item?.propItemGr_id) === 1;
}

export function rotuloItemOrcamento(item) {
  const nome = item?.propOrcItem_desc || item?.propItem_desc || item?.label || 'Item';
  const unidade = item?.unidade_label ? ` (${item.unidade_label})` : '';
  return `${nome}${unidade}`;
}

export function quantidadeInteiraPositiva(value) {
  if (value === '' || value === null || value === undefined) return null;
  const texto = String(value).trim().replace(',', '.');
  if (!/^\d+$/.test(texto)) return null;
  const numero = Number(texto);
  if (!Number.isInteger(numero) || numero <= 0) return null;
  return numero;
}

export function criarEstadoAtividadesVazio() {
  return {
    macroatividades: [],
    atividades: [],
    vinculosMacroItem: [],
    vinculosAtividadeItem: [],
    macrosParaDesativar: [],
    atividadesParaDesativar: [],
    relacoesMacroItemParaDesativar: [],
    relacoesAtividadeItemParaDesativar: [],
    relacoesMacroAtividadeParaDesativar: [],
  };
}

export function setoresDoCargo(cargoSetorAtiv, cargoId) {
  const cargo = Number(cargoId) || 0;
  if (!cargo) return [];
  return (cargoSetorAtiv || []).filter((linha) => Number(linha.cargo_id) === cargo);
}

export function setorPermitidoParaItem(item, setorAtivId, cargoSetorAtiv) {
  if (!itemEhRecursoHumano(item)) return false;
  const setor = Number(setorAtivId) || 0;
  if (!setor) return false;
  return setoresDoCargo(cargoSetorAtiv, item?.cargo_id)
    .some((linha) => Number(linha.setorAtiv_id) === setor);
}

function guardarId(lista, id) {
  const numero = Number(id) || 0;
  if (!numero || lista.includes(numero)) return lista;
  return [...lista, numero];
}

export function adicionarMacroatividade(estado, nome = '') {
  return {
    ...estado,
    macroatividades: [
      ...estado.macroatividades,
      {
        rowKey: novaChaveAtividade(),
        macroatividade_id: 0,
        relacaoPropMacroatividade_id: 0,
        macroatividade_nome: nome,
        inicioPrevDias: null,
        diasParaExecutar: null,
      },
    ],
  };
}

export function renomearMacroatividade(estado, rowKey, nome) {
  return {
    ...estado,
    macroatividades: estado.macroatividades.map((macro) => (
      macro.rowKey === rowKey ? { ...macro, macroatividade_nome: nome } : macro
    )),
  };
}

export function adicionarAtividade(estado, macroRowKey = null, nome = '') {
  return {
    ...estado,
    atividades: [
      ...estado.atividades,
      {
        rowKey: novaChaveAtividade(),
        atividade_id: 0,
        relacaoPropAtividade_id: 0,
        relacaoMacroatividadeAtividade_id: 0,
        atividade_nome: nome,
        macroRowKey: macroRowKey || null,
        inicioPrevDias: null,
        diasParaExecutar: null,
      },
    ],
  };
}

export function atualizarMacroatividade(estado, rowKey, campos) {
  return {
    ...estado,
    macroatividades: estado.macroatividades.map((macro) => (
      macro.rowKey === rowKey ? { ...macro, ...campos } : macro
    )),
  };
}

export function atualizarAtividade(estado, rowKey, campos) {
  return {
    ...estado,
    atividades: estado.atividades.map((atividade) => (
      atividade.rowKey === rowKey ? { ...atividade, ...campos } : atividade
    )),
  };
}

export function renomearAtividade(estado, rowKey, nome) {
  return {
    ...estado,
    atividades: estado.atividades.map((atividade) => (
      atividade.rowKey === rowKey ? { ...atividade, atividade_nome: nome } : atividade
    )),
  };
}

export function excluirAtividade(estado, rowKey) {
  const atividade = estado.atividades.find((item) => item.rowKey === rowKey);
  if (!atividade) return estado;
  const vinculos = estado.vinculosAtividadeItem.filter((vinculo) => vinculo.atividadeRowKey === rowKey);
  return {
    ...estado,
    atividades: estado.atividades.filter((item) => item.rowKey !== rowKey),
    vinculosAtividadeItem: estado.vinculosAtividadeItem.filter((vinculo) => vinculo.atividadeRowKey !== rowKey),
    atividadesParaDesativar: guardarId(estado.atividadesParaDesativar, atividade.atividade_id),
    relacoesAtividadeItemParaDesativar: vinculos.reduce(
      (lista, vinculo) => guardarId(lista, vinculo.relacao_id),
      estado.relacoesAtividadeItemParaDesativar
    ),
    relacoesMacroAtividadeParaDesativar: guardarId(
      estado.relacoesMacroAtividadeParaDesativar,
      atividade.relacaoMacroatividadeAtividade_id
    ),
  };
}

export function excluirMacroatividade(estado, rowKey) {
  const macro = estado.macroatividades.find((item) => item.rowKey === rowKey);
  if (!macro) return estado;
  const atividadesDaMacro = estado.atividades.filter((atividade) => atividade.macroRowKey === rowKey);
  return {
    ...estado,
    macroatividades: estado.macroatividades.filter((item) => item.rowKey !== rowKey),
    atividades: estado.atividades.map((atividade) => (
      atividade.macroRowKey === rowKey
        ? { ...atividade, macroRowKey: null, relacaoMacroatividadeAtividade_id: 0 }
        : atividade
    )),
    vinculosMacroItem: estado.vinculosMacroItem.filter((vinculo) => vinculo.macroRowKey !== rowKey),
    macrosParaDesativar: guardarId(estado.macrosParaDesativar, macro.macroatividade_id),
    relacoesMacroItemParaDesativar: estado.vinculosMacroItem
      .filter((vinculo) => vinculo.macroRowKey === rowKey)
      .reduce((lista, vinculo) => guardarId(lista, vinculo.relacao_id), estado.relacoesMacroItemParaDesativar),
    relacoesMacroAtividadeParaDesativar: atividadesDaMacro.reduce(
      (lista, atividade) => guardarId(lista, atividade.relacaoMacroatividadeAtividade_id),
      estado.relacoesMacroAtividadeParaDesativar
    ),
  };
}

export function incluirAtividadesNaMacro(estado, macroRowKey, atividadeRowKeys, quantidadesPorItem) {
  let proximo = estado;
  Object.entries(quantidadesPorItem || {}).forEach(([propItemRowKey, qtd]) => {
    const quantidade = quantidadeInteiraPositiva(qtd);
    if (!quantidade) return;
    proximo = definirVinculoMacro(proximo, macroRowKey, propItemRowKey, quantidade);
  });
  (atividadeRowKeys || []).forEach((rowKey) => {
    const atividade = proximo.atividades.find((item) => item.rowKey === rowKey);
    if (!atividade || atividade.macroRowKey === macroRowKey) return;
    proximo = moverAtividade(proximo, rowKey, macroRowKey);
  });
  return proximo;
}

function quantidadeDoItemNasAtividades(estado, macroRowKey, propItemRowKey) {
  const atividades = new Set(
    estado.atividades
      .filter((atividade) => atividade.macroRowKey === macroRowKey)
      .map((atividade) => atividade.rowKey)
  );
  return estado.vinculosAtividadeItem.reduce((soma, vinculo) => (
    atividades.has(vinculo.atividadeRowKey) && vinculo.propItemRowKey === propItemRowKey
      ? soma + (Number(vinculo.qtd) || 0)
      : soma
  ), 0);
}

export function garantirItensDaMacro(estado, macroRowKey) {
  if (!macroRowKey) return estado;
  const chaves = new Set();
  estado.atividades
    .filter((atividade) => atividade.macroRowKey === macroRowKey)
    .forEach((atividade) => {
      estado.vinculosAtividadeItem.forEach((vinculo) => {
        if (vinculo.atividadeRowKey === atividade.rowKey && Number(vinculo.qtd) > 0) {
          chaves.add(vinculo.propItemRowKey);
        }
      });
    });
  let proximo = estado;
  chaves.forEach((propItemRowKey) => {
    const necessario = quantidadeDoItemNasAtividades(proximo, macroRowKey, propItemRowKey);
    const atual = proximo.vinculosMacroItem.find((vinculo) => (
      vinculo.macroRowKey === macroRowKey && vinculo.propItemRowKey === propItemRowKey
    ));
    if (necessario > 0 && (!atual || Number(atual.qtd) < necessario)) {
      proximo = definirVinculoMacro(proximo, macroRowKey, propItemRowKey, necessario);
    }
  });
  return proximo;
}

export function itensDaMacro(estado, macroRowKey) {
  const chaves = new Set(
    estado.vinculosMacroItem
      .filter((vinculo) => vinculo.macroRowKey === macroRowKey && Number(vinculo.qtd) > 0)
      .map((vinculo) => vinculo.propItemRowKey)
  );
  return chaves;
}

export function moverAtividade(estado, atividadeRowKey, macroRowKey) {
  const destino = macroRowKey || null;
  const atividade = estado.atividades.find((item) => item.rowKey === atividadeRowKey);
  if (!atividade) return estado;
  const proximo = {
    ...estado,
    atividades: estado.atividades.map((item) => (
      item.rowKey === atividadeRowKey
        ? {
          ...item,
          macroRowKey: destino,
          relacaoMacroatividadeAtividade_id: destino ? item.relacaoMacroatividadeAtividade_id : 0,
        }
        : item
    )),
    relacoesMacroAtividadeParaDesativar: destino
      ? estado.relacoesMacroAtividadeParaDesativar
      : guardarId(estado.relacoesMacroAtividadeParaDesativar, atividade.relacaoMacroatividadeAtividade_id),
  };
  return destino ? garantirItensDaMacro(proximo, destino) : proximo;
}

function definirVinculo(lista, filtro, dados) {
  const existente = lista.find(filtro);
  if (existente) {
    return lista.map((vinculo) => (vinculo === existente ? { ...vinculo, ...dados } : vinculo));
  }
  return [...lista, { rowKey: novaChaveAtividade(), relacao_id: 0, ...dados }];
}

export function definirVinculoMacro(estado, macroRowKey, propItemRowKey, qtd) {
  const quantidade = quantidadeInteiraPositiva(qtd);
  if (!macroRowKey || !propItemRowKey || !quantidade) return estado;
  return {
    ...estado,
    vinculosMacroItem: definirVinculo(
      estado.vinculosMacroItem,
      (vinculo) => vinculo.macroRowKey === macroRowKey && vinculo.propItemRowKey === propItemRowKey,
      { macroRowKey, propItemRowKey, qtd: quantidade }
    ),
  };
}

export function removerVinculoMacro(estado, macroRowKey, propItemRowKey) {
  const vinculo = estado.vinculosMacroItem.find((item) => (
    item.macroRowKey === macroRowKey && item.propItemRowKey === propItemRowKey
  ));
  const atividadesAfetadas = estado.atividades
    .filter((atividade) => atividade.macroRowKey === macroRowKey)
    .map((atividade) => atividade.rowKey);
  const vinculosAtividadeRemovidos = estado.vinculosAtividadeItem.filter((item) => (
    atividadesAfetadas.includes(item.atividadeRowKey) && item.propItemRowKey === propItemRowKey
  ));
  return {
    ...estado,
    vinculosMacroItem: estado.vinculosMacroItem.filter((item) => item !== vinculo),
    vinculosAtividadeItem: estado.vinculosAtividadeItem.filter((item) => (
      !atividadesAfetadas.includes(item.atividadeRowKey) || item.propItemRowKey !== propItemRowKey
    )),
    relacoesMacroItemParaDesativar: guardarId(estado.relacoesMacroItemParaDesativar, vinculo?.relacao_id),
    relacoesAtividadeItemParaDesativar: vinculosAtividadeRemovidos.reduce(
      (lista, item) => guardarId(lista, item.relacao_id),
      estado.relacoesAtividadeItemParaDesativar
    ),
  };
}

export function definirItensDaAtividade(estado, atividadeRowKey, quantidadesPorItem, setoresPorItem = {}) {
  const atividade = estado.atividades.find((item) => item.rowKey === atividadeRowKey);
  if (!atividade) return estado;
  const atuais = estado.vinculosAtividadeItem.filter((vinculo) => vinculo.atividadeRowKey === atividadeRowKey);
  const porChave = new Map(atuais.map((vinculo) => [vinculo.propItemRowKey, vinculo]));
  let desativar = estado.relacoesAtividadeItemParaDesativar;
  const proximos = [];
  const chaves = new Set([
    ...Object.keys(quantidadesPorItem || {}),
    ...atuais.map((vinculo) => vinculo.propItemRowKey),
  ]);

  chaves.forEach((propItemRowKey) => {
    const existente = porChave.get(propItemRowKey);
    const quantidade = quantidadeInteiraPositiva(quantidadesPorItem?.[propItemRowKey]);
    if (!quantidade) {
      if (existente) desativar = guardarId(desativar, existente.relacao_id);
      return;
    }
    const setorInformado = Object.prototype.hasOwnProperty.call(setoresPorItem || {}, propItemRowKey)
      ? (Number(setoresPorItem[propItemRowKey]) || null)
      : (existente?.setorAtiv_id ?? null);
    proximos.push(existente
      ? { ...existente, qtd: quantidade, setorAtiv_id: setorInformado }
      : {
        rowKey: novaChaveAtividade(),
        relacao_id: 0,
        atividadeRowKey,
        propItemRowKey,
        qtd: quantidade,
        setorAtiv_id: setorInformado,
      });
  });

  const proximo = {
    ...estado,
    vinculosAtividadeItem: [
      ...estado.vinculosAtividadeItem.filter((vinculo) => vinculo.atividadeRowKey !== atividadeRowKey),
      ...proximos,
    ],
    relacoesAtividadeItemParaDesativar: desativar,
  };
  return atividade.macroRowKey ? garantirItensDaMacro(proximo, atividade.macroRowKey) : proximo;
}

export function definirVinculoAtividade(estado, atividadeRowKey, propItemRowKey, qtd, setorAtivId = null) {
  const quantidade = quantidadeInteiraPositiva(qtd);
  const atividade = estado.atividades.find((item) => item.rowKey === atividadeRowKey);
  if (!atividade || !propItemRowKey || !quantidade) return estado;
  const proximo = {
    ...estado,
    vinculosAtividadeItem: definirVinculo(
      estado.vinculosAtividadeItem,
      (vinculo) => vinculo.atividadeRowKey === atividadeRowKey && vinculo.propItemRowKey === propItemRowKey,
      {
        atividadeRowKey,
        propItemRowKey,
        qtd: quantidade,
        setorAtiv_id: Number(setorAtivId) || null,
      }
    ),
  };
  return atividade.macroRowKey ? garantirItensDaMacro(proximo, atividade.macroRowKey) : proximo;
}

export function atualizarSetorVinculo(estado, atividadeRowKey, propItemRowKey, setorAtivId) {
  return {
    ...estado,
    vinculosAtividadeItem: estado.vinculosAtividadeItem.map((vinculo) => (
      vinculo.atividadeRowKey === atividadeRowKey && vinculo.propItemRowKey === propItemRowKey
        ? { ...vinculo, setorAtiv_id: Number(setorAtivId) || null }
        : vinculo
    )),
  };
}

export function removerVinculoAtividade(estado, atividadeRowKey, propItemRowKey) {
  const vinculo = estado.vinculosAtividadeItem.find((item) => (
    item.atividadeRowKey === atividadeRowKey && item.propItemRowKey === propItemRowKey
  ));
  return {
    ...estado,
    vinculosAtividadeItem: estado.vinculosAtividadeItem.filter((item) => item !== vinculo),
    relacoesAtividadeItemParaDesativar: guardarId(estado.relacoesAtividadeItemParaDesativar, vinculo?.relacao_id),
  };
}

export function removerVinculosDoItem(estado, propItemRowKey) {
  if (!propItemRowKey) return estado;
  return {
    ...estado,
    vinculosMacroItem: estado.vinculosMacroItem.filter((vinculo) => vinculo.propItemRowKey !== propItemRowKey),
    vinculosAtividadeItem: estado.vinculosAtividadeItem.filter((vinculo) => vinculo.propItemRowKey !== propItemRowKey),
    relacoesMacroItemParaDesativar: estado.vinculosMacroItem
      .filter((vinculo) => vinculo.propItemRowKey === propItemRowKey)
      .reduce((lista, vinculo) => guardarId(lista, vinculo.relacao_id), estado.relacoesMacroItemParaDesativar),
    relacoesAtividadeItemParaDesativar: estado.vinculosAtividadeItem
      .filter((vinculo) => vinculo.propItemRowKey === propItemRowKey)
      .reduce((lista, vinculo) => guardarId(lista, vinculo.relacao_id), estado.relacoesAtividadeItemParaDesativar),
  };
}

export function limparSetoresInvalidos(estado, propItens, cargoSetorAtiv) {
  const porChave = new Map((propItens || []).map((item) => [chaveItemOrcamento(item), item]));
  return {
    ...estado,
    vinculosAtividadeItem: estado.vinculosAtividadeItem.map((vinculo) => {
      const item = porChave.get(vinculo.propItemRowKey);
      if (!item || !itemEhRecursoHumano(item)) {
        return vinculo.setorAtiv_id ? { ...vinculo, setorAtiv_id: null } : vinculo;
      }
      if (setorPermitidoParaItem(item, vinculo.setorAtiv_id, cargoSetorAtiv)) return vinculo;
      return { ...vinculo, setorAtiv_id: null };
    }),
  };
}

export function conferenciaItens(propItens, vinculosAtividadeItem) {
  return (propItens || []).map((item) => {
    const chave = chaveItemOrcamento(item);
    const quantidadeProposta = Number(item?.propOrcItem_qtd) || 0;
    const quantidadeAtividades = (vinculosAtividadeItem || []).reduce((soma, vinculo) => (
      vinculo.propItemRowKey === chave ? soma + (Number(vinculo.qtd) || 0) : soma
    ), 0);
    return {
      chave,
      rotulo: rotuloItemOrcamento(item),
      quantidadeProposta,
      quantidadeAtividades,
      diferenca: quantidadeProposta - quantidadeAtividades,
    };
  });
}

export function subtotalAtividadesDaMacro(estado, macroRowKey, propItemRowKey) {
  const atividades = new Set(
    estado.atividades
      .filter((atividade) => atividade.macroRowKey === macroRowKey)
      .map((atividade) => atividade.rowKey)
  );
  return estado.vinculosAtividadeItem.reduce((soma, vinculo) => (
    atividades.has(vinculo.atividadeRowKey) && vinculo.propItemRowKey === propItemRowKey
      ? soma + (Number(vinculo.qtd) || 0)
      : soma
  ), 0);
}

export function validarConclusaoAtividades(estado, propItens, cargoSetorAtiv) {
  const mensagens = [];
  const itens = propItens || [];
  const porChave = new Map(itens.map((item) => [chaveItemOrcamento(item), item]));

  conferenciaItens(itens, estado.vinculosAtividadeItem).forEach((linha) => {
    if (linha.diferenca !== 0) {
      mensagens.push(`${linha.rotulo}: a proposta tem ${linha.quantidadeProposta} e as atividades somam ${linha.quantidadeAtividades}.`);
    }
  });

  estado.macroatividades.forEach((macro) => {
    const nome = (macro.macroatividade_nome || '').trim() || 'Macroatividade sem nome';
    if (!(macro.macroatividade_nome || '').trim()) {
      mensagens.push('Toda macroatividade precisa de nome.');
    }
    const atividades = estado.atividades.filter((atividade) => atividade.macroRowKey === macro.rowKey);
    const itensMacro = estado.vinculosMacroItem.filter((vinculo) => vinculo.macroRowKey === macro.rowKey && Number(vinculo.qtd) > 0);
    if (!atividades.length) mensagens.push(`${nome} precisa de ao menos uma atividade.`);
    if (!itensMacro.length) mensagens.push(`${nome} precisa de ao menos um item.`);
    itensMacro.forEach((vinculo) => {
      const consumido = subtotalAtividadesDaMacro(estado, macro.rowKey, vinculo.propItemRowKey);
      if (consumido !== Number(vinculo.qtd)) {
        const item = porChave.get(vinculo.propItemRowKey);
        mensagens.push(`${nome}: ${rotuloItemOrcamento(item)} tem ${vinculo.qtd} na macroatividade e ${consumido} nas atividades dela.`);
      }
    });
  });

  estado.atividades.forEach((atividade) => {
    const nome = (atividade.atividade_nome || '').trim() || 'Atividade sem nome';
    if (!(atividade.atividade_nome || '').trim()) {
      mensagens.push('Toda atividade precisa de nome.');
    }
    const vinculos = estado.vinculosAtividadeItem.filter((vinculo) => (
      vinculo.atividadeRowKey === atividade.rowKey && Number(vinculo.qtd) > 0
    ));
    if (!vinculos.length) mensagens.push(`${nome} precisa de ao menos um item.`);
    vinculos.forEach((vinculo) => {
      const item = porChave.get(vinculo.propItemRowKey);
      if (!itemEhRecursoHumano(item)) return;
      if (!setorPermitidoParaItem(item, vinculo.setorAtiv_id, cargoSetorAtiv)) {
        mensagens.push(`${nome}: escolha o setor da atividade para ${rotuloItemOrcamento(item)}.`);
      }
    });
  });

  return { ok: mensagens.length === 0, mensagens };
}

export function valorUnitarioItem(item) {
  const raw = item?.propOrcItem_valor;
  if (raw === null || raw === undefined || raw === '') return 0;
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : 0;
  const texto = String(raw).trim();
  const temVirgula = texto.includes(',');
  const temPonto = texto.includes('.');
  let normalizado = texto;
  if (temVirgula && temPonto) normalizado = texto.replace(/\./g, '').replace(',', '.');
  else if (temVirgula) normalizado = texto.replace(',', '.');
  const numero = Number(normalizado);
  return Number.isFinite(numero) ? numero : 0;
}

export function custoDaMacro(estado, macroRowKey, propItens) {
  const porChave = new Map((propItens || []).map((item) => [chaveItemOrcamento(item), item]));
  return (estado?.vinculosMacroItem || []).reduce((soma, vinculo) => {
    if (vinculo.macroRowKey !== macroRowKey) return soma;
    return soma + valorUnitarioItem(porChave.get(vinculo.propItemRowKey)) * (Number(vinculo.qtd) || 0);
  }, 0);
}

export function custoDaAtividade(estado, atividadeRowKey, propItens) {
  const porChave = new Map((propItens || []).map((item) => [chaveItemOrcamento(item), item]));
  return (estado?.vinculosAtividadeItem || []).reduce((soma, vinculo) => {
    if (vinculo.atividadeRowKey !== atividadeRowKey) return soma;
    return soma + valorUnitarioItem(porChave.get(vinculo.propItemRowKey)) * (Number(vinculo.qtd) || 0);
  }, 0);
}

function diaInformado(value) {
  if (value === null || value === undefined || value === '') return null;
  const numero = Number(value);
  if (!Number.isInteger(numero) || numero < 0) return null;
  return numero;
}

export function montarEstadoCarregado(carga) {
  const estado = criarEstadoAtividadesVazio();
  const macroKeyById = new Map();
  estado.macroatividades = (carga?.macros || []).map((macro) => {
    const rowKey = String(macro.macroatividade_id);
    macroKeyById.set(Number(macro.macroatividade_id), rowKey);
    return {
      rowKey,
      macroatividade_id: Number(macro.macroatividade_id) || 0,
      relacaoPropMacroatividade_id: Number(macro.relacaoPropMacroatividade_id) || 0,
      macroatividade_nome: macro.macroatividade_nome || '',
      inicioPrevDias: diaInformado(macro.macroatividade_inicioPrevDias ?? macro.inicioPrevDias),
      diasParaExecutar: diaInformado(macro.macroatividade_diasParaExecutar ?? macro.diasParaExecutar),
    };
  });
  estado.atividades = (carga?.atividades || []).map((atividade) => {
    const macroId = Number(atividade.macroatividade_id) || 0;
    return {
      rowKey: String(atividade.atividade_id),
      atividade_id: Number(atividade.atividade_id) || 0,
      relacaoPropAtividade_id: Number(atividade.relacaoPropAtividade_id) || 0,
      relacaoMacroatividadeAtividade_id: Number(atividade.relacaoMacroatividadeAtividade_id) || 0,
      atividade_nome: atividade.atividade_nome || '',
      macroRowKey: macroId ? (macroKeyById.get(macroId) || null) : null,
      inicioPrevDias: diaInformado(atividade.atividade_inicioPrevDias ?? atividade.inicioPrevDias),
      diasParaExecutar: diaInformado(atividade.atividade_diasParaExecutar ?? atividade.diasParaExecutar),
    };
  });
  estado.vinculosMacroItem = (carga?.vinculosMacro || []).map((vinculo) => ({
    rowKey: `macro-item-${vinculo.relacao_id}`,
    relacao_id: Number(vinculo.relacao_id) || 0,
    macroRowKey: macroKeyById.get(Number(vinculo.macroatividade_id)) || '',
    propItemRowKey: String(vinculo.propOrcItem_id),
    qtd: Number(vinculo.qtd) || 0,
  })).filter((vinculo) => vinculo.macroRowKey && vinculo.propItemRowKey);
  estado.vinculosAtividadeItem = (carga?.vinculosAtividade || []).map((vinculo) => ({
    rowKey: `atividade-item-${vinculo.relacao_id}`,
    relacao_id: Number(vinculo.relacao_id) || 0,
    atividadeRowKey: String(vinculo.atividade_id),
    propItemRowKey: String(vinculo.propOrcItem_id),
    qtd: Number(vinculo.qtd) || 0,
    setorAtiv_id: Number(vinculo.setorAtiv_id) || null,
  })).filter((vinculo) => vinculo.atividadeRowKey && vinculo.propItemRowKey);
  return estado;
}

export function serializarAtividadesParaRascunho(estado, propItens) {
  const porChave = new Map((propItens || []).map((item) => [chaveItemOrcamento(item), item]));
  return {
    macroatividades: (estado?.macroatividades || []).map((macro) => ({
      rowKey: macro.rowKey,
      macroatividade_id: Number(macro.macroatividade_id) || 0,
      relacaoPropMacroatividade_id: Number(macro.relacaoPropMacroatividade_id) || 0,
      macroatividade_nome: macro.macroatividade_nome || '',
      inicioPrevDias: diaInformado(macro.inicioPrevDias),
      diasParaExecutar: diaInformado(macro.diasParaExecutar),
      itens: (estado.vinculosMacroItem || [])
        .filter((vinculo) => vinculo.macroRowKey === macro.rowKey)
        .map((vinculo) => ({
          relacao_id: Number(vinculo.relacao_id) || 0,
          propItemRowKey: vinculo.propItemRowKey,
          qtd: Number(vinculo.qtd) || 0,
        })),
    })),
    atividades: (estado?.atividades || []).map((atividade) => ({
      rowKey: atividade.rowKey,
      atividade_id: Number(atividade.atividade_id) || 0,
      relacaoPropAtividade_id: Number(atividade.relacaoPropAtividade_id) || 0,
      relacaoMacroatividadeAtividade_id: Number(atividade.relacaoMacroatividadeAtividade_id) || 0,
      atividade_nome: atividade.atividade_nome || '',
      inicioPrevDias: diaInformado(atividade.inicioPrevDias),
      diasParaExecutar: diaInformado(atividade.diasParaExecutar),
      macroRowKey: atividade.macroRowKey || null,
      itens: (estado.vinculosAtividadeItem || [])
        .filter((vinculo) => vinculo.atividadeRowKey === atividade.rowKey)
        .map((vinculo) => {
          const item = porChave.get(vinculo.propItemRowKey);
          return {
            relacao_id: Number(vinculo.relacao_id) || 0,
            propItemRowKey: vinculo.propItemRowKey,
            qtd: Number(vinculo.qtd) || 0,
            propItemGr_id: Number(item?.propItemGr_id) || 0,
            setorAtiv_id: itemEhRecursoHumano(item) ? (Number(vinculo.setorAtiv_id) || 0) : 0,
          };
        }),
    })),
    macrosParaDesativar: estado?.macrosParaDesativar || [],
    atividadesParaDesativar: estado?.atividadesParaDesativar || [],
    relacoesMacroItemParaDesativar: estado?.relacoesMacroItemParaDesativar || [],
    relacoesAtividadeItemParaDesativar: estado?.relacoesAtividadeItemParaDesativar || [],
    relacoesMacroAtividadeParaDesativar: estado?.relacoesMacroAtividadeParaDesativar || [],
  };
}

export function vinculosRecursoHumanoSemSetor(estado, propItens, cargoSetorAtiv) {
  const porChave = new Map((propItens || []).map((item) => [chaveItemOrcamento(item), item]));
  return estado.vinculosAtividadeItem.filter((vinculo) => {
    const item = porChave.get(vinculo.propItemRowKey);
    return itemEhRecursoHumano(item) && !setorPermitidoParaItem(item, vinculo.setorAtiv_id, cargoSetorAtiv);
  });
}
